import script from "./FullScreenOverlayMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenOverlayMobile.vue?vue&type=script&setup=true&lang=ts"

import "./FullScreenOverlayMobile.vue?vue&type=style&index=0&id=1908ae97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1908ae97"]])

export default __exports__